<div class="modal-header mb-ng-modal-header">
  <div class="modal-title mb-ng-modal-title"
       data-cy="mb-ng-modal-title">
    <span [innerHTML]="productName"></span>
  </div>
  <button type="button"
          class="mb-ng-modal-close close"
          aria-label="Close"
          data-cy="mb-ng-modal-close"
          (click)="modal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body mb-ng-modal-body hide-scrollbar"
     data-cy="mb-ng-modal-body">
  <ng-container *ngIf="(activeImage && gallery && productName) || activeImage?.videoId">
    <div class="row no-gutters mb-modal-media">
      <div class="mb-modal-carousel-wrapper"
           data-cy="mbModalCarouselWrapper"
           *ngIf="hasApplicationData && gallery !== undefined"
           [ngClass]="{'mb-hide-carousel' : isSingleImage}" >
        <mb-pdp-gallery-carousel [imagesData]="gallery"
                                 [activeImageIndex]="activeImageIndex"
                                 (activeImage)="onGalleryClickedHandler($event)"
                                 [videoThumbnails]="videoThumbnails">
        </mb-pdp-gallery-carousel>
      </div>

      <div *ngIf="activeImage"
           data-cy="mbGalleryModalMainImageWrapper"
           style="overflow: auto"
           [ngClass]="[(hasApplicationData) ? 'col' : 'col-12', 'text-center mb-modal-thumbnail hide-scrollbar mx-lg-auto use-to-remove-blocker-for-modal']">

        <ng-container *ngIf="activeImage.videoId; else showImage">
          <div [id]="containerId"
               mbUcBlockable
               [ucId]="activeImage?.videoId"
               [ucService]="ucService.MOVING_IMAGE"
               (unBlocked)="openVideo(activeImage?.videoId)"></div>
        </ng-container>

        <ng-template #showImage>
          <img class="mb-modal-thumbnail-image"
               title="Modal gallery main image"
               alt="Modal gallery main image"
               aria-label="Gallery main image missing from modal"
               [ngClass]="{'mb-show-max-size' : isSingleImage}"
               [src]="activeImage.image"/>
        </ng-template>

        <div *ngIf="activeImage?.headline"
             class="mb-modal-thumbnail-headline text-left"
             aria-label="Headline text of main gallery image"
             data-cy="mbModalHeadlineText">
          <strong>{{'mbproduct.image' | mbTranslate}}</strong>
          <span [innerHTML]="activeImage?.headline"></span>
        </div>
      </div>
    </div>

    <div *ngIf="activeImage?.legend"
         class="row no-gutters mb-modal-legend d-flex flex-column"
         aria-label="Legend text of main gallery image"
         data-cy="mbModalLegendText">
      <span class="mb-modal-description">{{'mbproduct.description' | mbTranslate}}</span>
      <span class="mb-modal-info" [innerHTML]="activeImage?.legend"></span>
    </div>
  </ng-container>
</div>


